import React from "react";
const Logo = (): React.JSX.Element => (
  <svg
    width="82"
    height="30"
    viewBox="0 0 82 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M77.2001 2.47996V0.719961H76.5601V0.209961H78.4301V0.719961H77.7901V2.46996H77.2001V2.47996Z"
      fill="black"
    />
    <path
      d="M80.71 2.47996V0.949961L80.13 2.47996H79.87L79.29 0.949961V2.47996H78.71V0.209961H79.52L80 1.48996L80.48 0.209961H81.3V2.47996H80.71Z"
      fill="black"
    />
    <path
      d="M44.0099 22.39L39.4299 9.37L42.9899 8.23L45.9799 17.71L48.9899 6.31L52.5499 5.17L47.9499 21.12L44.0099 22.38V22.39ZM53.4199 5.26L55.5999 4.56V0L36.3599 6.14V29.03L53.4099 23.58V5.26H53.4199Z"
      fill="black"
    />
    <path
      d="M10.3198 10.2003L7.83984 10.9903V14.2403L8.64984 13.9803L10.3198 13.4503C11.1398 13.1903 11.8298 12.3403 11.8298 11.3403C11.8298 10.3403 11.1398 9.93026 10.3198 10.2003Z"
      fill="black"
    />
    <path
      d="M12.62 20.8C11.93 21.02 11.3 20.76 10.99 20.12L9.72 17.47C9.55 17.12 9.21 16.98 8.83 17.1C8.28 17.28 7.84 17.94 7.84 18.6V22.33L4.7 23.33V8.85L10.79 6.9C13.49 6.04 15.02 7.68 15.02 10.37C15.02 12.81 13.81 14.53 12.7 15.4C12.66 15.43 12.62 15.46 12.59 15.48L15.07 20.01L12.6 20.8H12.62ZM0 6.14V29.03L17.05 23.58V5.26L19.23 4.56V0L0 6.14Z"
      fill="black"
    />
    <path
      d="M64.9102 10.2003L62.4302 10.9903V14.2403L63.2402 13.9803L64.9102 13.4503C65.7302 13.1903 66.4202 12.3403 66.4202 11.3403C66.4202 10.3403 65.7302 9.93026 64.9102 10.2003Z"
      fill="black"
    />
    <path
      d="M67.2098 20.8C66.5198 21.02 65.8898 20.76 65.5798 20.12L64.3098 17.47C64.1398 17.12 63.7998 16.98 63.4198 17.1C62.8698 17.28 62.4298 17.94 62.4298 18.6V22.33L59.2898 23.33V8.85L65.3798 6.9C68.0798 6.04 69.6098 7.68 69.6098 10.37C69.6098 12.81 68.3998 14.53 67.2898 15.4C67.2498 15.43 67.2098 15.46 67.1798 15.48L69.6598 20.01L67.1898 20.8H67.2098ZM54.5898 6.14V29.03L73.8298 22.89V0L54.5898 6.14Z"
      fill="black"
    />
    <path
      d="M30.3349 15.7525C31.2737 13.7833 30.8991 11.6456 29.4983 10.9777C28.0974 10.3098 26.2007 11.3647 25.2619 13.3339C24.3231 15.3031 24.6976 17.4408 26.0985 18.1087C27.4993 18.7766 29.396 17.7217 30.3349 15.7525Z"
      fill="black"
    />
    <path
      d="M27.8102 22.19C24.2602 23.33 21.3802 20.82 21.3802 16.59C21.3802 12.36 24.2602 8.02 27.8102 6.89C31.3602 5.75 34.2402 8.26 34.2402 12.49C34.2402 16.72 31.3602 21.06 27.8102 22.19ZM18.1902 6.14V29.03L35.2402 23.58V5.26L37.4202 4.56V0L18.1802 6.14H18.1902Z"
      fill="black"
    />
  </svg>
);

export default Logo;
